import React from "react";
import { toast } from "react-toastify";
import Input, { InputProps } from "./Input";

interface Option {
  Type: string;
  Value?: any;
  Data?: any;
  Order?: number;
  ValueFrom?: string;
  ComponentConfig?: {
    isDataCategory?: boolean;
  };
}

interface OptionInputProps extends Omit<InputProps, 'value' | 'onChange' | 'onCreateOption'> {
  isSummary?: boolean;
  onChange: (values: Option[]) => void;
  optionType: string;
  value?: Option[];
  operator?: string;
  ifOptionTypeHas?: any;
  isAvailableIn?: any;
  condition?: any;
  valueType?: "data" | "value";
  isDataCategory?: boolean;
  valueFrom?: string;
  onCreateOption?: (v: any) => any;
}

export default function OptionInput({
  isSummary,
  onChange,
  optionType,
  value,
  // value is all the options (will be filtered according to optionType)
  operator,
  ifOptionTypeHas,
  isAvailableIn,
  condition,
  valueType,
  isDataCategory,
  valueFrom,
  ...props
}: OptionInputProps) {
  return (
    <Input
      isSummary={isSummary}
      {...props}
      value={
        value
          ?.filter((o) => o.Type === optionType)
          .sort((a, b) => (a.Order ?? 0) - (b.Order ?? 0))
          .map((o) => (valueType === "data" ? o.Data : o.Value)) ?? []
      }
      onCreateOption={(v) => {
        if (!props.onCreateOption) return;
        onChange([
          ...(value?.filter((o) => props.isMulti || o.Type !== optionType) ??
            []),
          {
            Type: optionType,
            ...(valueFrom ? { ValueFrom: valueFrom } : {}),
            Value: props.onCreateOption(v),
            ...(isDataCategory
              ? { ComponentConfig: { isDataCategory: true } }
              : {}),
          },
        ]);
      }}
      onChange={(options) => {
        // check for number of options for BETWEEN
        if (operator === "compare:between" && options.length > 2) {
          toast.error("You can not have more than 2 options for BETWEEN");
          return;
        }
        // check for input types
        if (props.type === "number") {
          // eslint-disable-next-line no-restricted-syntax
          for (const opt of options) {
            if (isNaN(opt)) {
              toast.error("Must be a number");
              return;
            }
            if (props.min != null && opt < props.min) {
              toast.error(`Must be a greater than ${props.min}`);
              return;
            }
            if (props.max != null && opt > props.max) {
              toast.error(`Must be a less than ${props.max}`);
              return;
            }
          }
        }
        // join array of other options with the edited ones
        onChange([
          ...(value?.filter((o) => o.Type !== optionType) ?? []),
          ...options.map((o) => ({
            ...(valueType === "data" ? { Data: o } : { Value: o }),
            ...(valueFrom ? { ValueFrom: valueFrom } : {}),
            Type: optionType,
            ...(isDataCategory
              ? { ComponentConfig: { isDataCategory: true } }
              : {}),
          })),
        ]);
      }}
    />
  );
}
